import * as React from "react";

import {
  Context,
  fetchTemporaryToken,
  clearTemporaryToken,
} from "../../managerStore";
import { FileDownloader } from "../../molecules/FileDownloader";
import { ModalContext } from "../../libs/ModalProvider";

export interface ITokenizedDownload {
  buildUrl: (temporaryToken: string) => string;
  content: React.ReactElement;
}

// ファイルは新規タブへのページ遷移で開くため X-APP-SESSIONID ヘッダーを付けられない。
// 代わりにワンタイムトークンをURLに載せる必要があり、トークン取得を待ってからモーダルを出す
const useTokenizedDownload = () => {
  const { state, dispatch } = React.useContext(Context);
  const modalCtx = React.useContext(ModalContext);
  const [download, setDownload] = React.useState<ITokenizedDownload | null>(
    null,
  );

  React.useEffect(() => {
    if (!state.temporary_token || !download) {
      return;
    }
    modalCtx.actions.showModal(
      <FileDownloader
        closeModal={modalCtx.actions.closeModal}
        content={download.content}
        url={download.buildUrl(state.temporary_token)}
      />,
    );
    dispatch(clearTemporaryToken());
    setDownload(null);
  }, [state.temporary_token, download, modalCtx.actions, dispatch]);

  return React.useCallback(
    (request: ITokenizedDownload) => {
      setDownload(request);
      dispatch(fetchTemporaryToken());
    },
    [dispatch],
  );
};

export default useTokenizedDownload;
